import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useSubscription } from "@/hooks/useSubscription";
import { useSingleInstance } from "@/hooks/useSingleInstance";

export function PastDueBanner() {
  const { status } = useSubscription();
  const isOwner = useSingleInstance("past-due-banner");
  const [loadingPortal, setLoadingPortal] = useState(false);

  const handlePortal = async () => {
    try {
      setLoadingPortal(true);
      const { data, error } = await supabase.functions.invoke("customer-portal");
      if (error) throw error;
      if (data?.url) window.location.href = data.url;
    } catch (e: any) {
      toast.error(e?.message || "Erro ao abrir portal");
    } finally {
      setLoadingPortal(false);
    }
  };

  if (!isOwner || (status !== "past_due" && status !== "unpaid")) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-destructive/30 bg-destructive/10 px-6 py-3 text-destructive">
      <div className="flex items-center gap-2 text-sm font-medium">
        <AlertTriangle className="h-4 w-4" />
        <span>
          {status === "past_due"
            ? "Não conseguimos processar seu pagamento — atualize o cartão para não perder o acesso"
            : "Seu acesso está suspenso por falta de pagamento — atualize o cartão para reativar agora mesmo"}
        </span>
      </div>
      <Button size="sm" variant="destructive" onClick={handlePortal} disabled={loadingPortal}>
        {loadingPortal ? <Loader2 className="h-4 w-4 animate-spin" /> : "Atualizar cartão"}
      </Button>
    </div>
  );
}

export default PastDueBanner;
